<template>
    <div>
        <h1 class="display-heading">My Calendar</h1>

        <div class="mb-3">
            <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'doctor-create-timeslots'}">Set Free Time Slots</router-link>
        </div>
        <div>
            <div id='calendar'></div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import 'fullcalendar';
export default {
    mounted () {
        this.dateStartIso8601 = moment().startOf('day').toISOString(true);
        this.dateEndIso8601 = moment().startOf('day').add(15, 'days').toISOString(true);
        this.axios.get('EventCalendar/GetEventCalendar', {
            'params': {
                's': this.dateStartIso8601,
                'e': this.dateEndIso8601
            }
        }).then(({ data }) => {
            let eventList = data.data;

            eventList.events.forEach(e => {
                if (e.title === 'Scheduled Appointment') {
                    e.backgroundColor = 'red';
                }
            });

            $('#calendar').fullCalendar({
                'defaultView': 'agenda15Days',
                'eventLimit': true,
                'timeFormat': 'hh:mm a',
                'eventRender': function (eventObj, $el) {
                    $el.popover({
                        'title': eventObj.time,
                        'content': eventObj.title,
                        'trigger': 'hover',
                        'placement': 'top',
                        'container': 'body'
                    });
                },
                'events': eventList,
                'eventColor': '#009344',
                'eventTextColor': '#fff',

                'views': {
                    'agenda15Days': {
                        'type': 'agenda',
                        'duration': { 'days': 15 }
                    }
                }
            });
        });
    },
    data () {
        return {
            'dateStartIso8601': null,
            'dateEndIso8601': null
        };
    }
};
</script>
